const themes = {
  dark: {
    colors: {
      text: '#fff',
      background: '#272a2b',
    },
    weights: {
      weight: '300'
    }
  },
  light: {
    colors: {
      text: '#272a2b',
      background: '#fff',
    },
    weights: {
      weight: '400'
    }
  }
};

export default themes;